import React, { Component } from 'react';
import cx from 'classnames';
import FooterLegal from './footer-legal';
import { withWindow } from '../../decorators/window';
import { BUSCADOR, CHAT_URLS, REGISTRO } from '../../constants/urls';
import { openUrlInNewWindow } from '../../utilities/helpers';

class Footer extends Component {
  render() {
    return (
      <footer
        aria-label='footer'
        role='contentinfo'>
        { this.renderMainFooter() }
      </footer>
    );
  }
  renderMainFooter() {
    const { 
      country, 
      hideMenuList,
      isWhiteBackground, 
      language, 
    } = this.props;

    const CarryOnTileClasses = cx({
      'Footer': !hideMenuList,
      'Footer-no-menu': hideMenuList,
    });
    
    return (
      <div className={ CarryOnTileClasses }>
        <FooterLegal
          country={ country }
          hideMenuList={ hideMenuList }
          isWhiteBackground={ isWhiteBackground }
          language={ language }
        />
      </div>
    );
  }

  handleSignUp() {
    const newsletterURL = REGISTRO.classic.mx;
    openUrlInNewWindow(newsletterURL, 640, 480);
  }

  handleOpenSearchModal() {
    const url = BUSCADOR.classic.mx;
    window.open(url, '_blank');
  }

  handleOpenChat() {
    const url = CHAT_URLS.classic.mx;
    openUrlInNewWindow(url);
  }
}

export default withWindow(Footer);
